// Zásady ochrany osobních údajů Analytical Platform (CS)
// Generated from the source Word document - keep the wording verbatim.
import type { LegalDocument } from "./types";

const privacyPolicyCs: LegalDocument = {
  "title": "Zásady ochrany osobních údajů Analytical Platform",
  "effectiveFrom": "Účinné od 18. 09. 2026",
  "sections": [
    {
      "heading": "1. Úvodní ustanovení",
      "blocks": [
        {
          "kind": "clause",
          "number": "1.1.",
          "text": "Tyto zásady ochrany osobních údajů (dále jen „Zásady“) upravují zpracování osobních údajů v souvislosti s používáním technologické platformy Analytical Platform, jednotlivých aplikací, produktů, nástrojů a funkcionalit poskytovaných jejím prostřednictvím a souvisejících služeb (dále společně jen „Služba“)."
        },
        {
          "kind": "clause",
          "number": "1.2.",
          "text": "Provozovatelem Analytical Platform je CCFR, sdružení společností CCF RESEARCH, a.s. a CCFR SOFTWARE, s.r.o. (dále jen „Provozovatel“)."
        },
        {
          "kind": "clause",
          "number": "1.3.",
          "text": "Analytical Platform představuje technologické prostředí, jehož prostřednictvím Provozovatel zpřístupňuje Uživatelům jednotlivé aplikace, produkty, nástroje a související funkcionality. Jednotlivé aplikace nebo produkty mohou být prezentovány také prostřednictvím samostatných webových stránek a mohou využívat společný uživatelský účet Analytical Platform."
        },
        {
          "kind": "clause",
          "number": "1.4.",
          "text": "Rozsah zpracovávaných osobních údajů se může lišit podle toho, které aplikace, produkty nebo funkcionality Uživatel používá."
        },
        {
          "kind": "clause",
          "number": "1.5.",
          "text": "Provozovatel zpracovává osobní údaje v souladu s nařízením Evropského parlamentu a Rady (EU) 2016/679 (dále jen „GDPR“) a dalšími příslušnými právními předpisy."
        }
      ]
    },
    {
      "heading": "2. Jaké osobní údaje zpracováváme",
      "blocks": [
        {
          "kind": "clause",
          "number": "2.1.",
          "text": "V závislosti na způsobu, jakým Uživatel používá Službu, může Provozovatel zpracovávat zejména následující osobní údaje:"
        },
        {
          "kind": "bullets",
          "items": [
            "identifikační a kontaktní údaje, zejména jméno, příjmení, e-mailovou adresu, telefonní číslo a případně údaje o společnosti, za kterou Uživatel jedná;",
            "údaje o uživatelském účtu, zejména údaje potřebné pro registraci, přihlášení, správu účtu, nastavení a preference Uživatele;",
            "údaje o předplatném a platbách, zejména informace o zvoleném tarifu, stavu předplatného, platbách a fakturační údaje;",
            "údaje související s používáním Služby, zejména informace o používaných aplikacích a funkcionalitách, nastavení Uživatele, uložených výstupech, zvolených parametrech a dalších úkonech prováděných prostřednictvím Služby;",
            "údaje související s technickým propojením s Brokerem, pokud Uživatel takové propojení využívá;",
            "údaje o komunikaci, zejména obsah komunikace se zákaznickou nebo technickou podporou;",
            "technické a provozní údaje, zejména IP adresu, typ zařízení, operační systém, internetový prohlížeč, datum a čas přístupu, provozní a diagnostické údaje a informace o používání Služby."
          ]
        },
        {
          "kind": "clause",
          "number": "2.2.",
          "text": "Provozovatel zpracovává pouze osobní údaje, které jsou přiměřené a nezbytné s ohledem na příslušný účel zpracování."
        },
        {
          "kind": "clause",
          "number": "2.3.",
          "text": "Pokud Uživatel poskytne Provozovateli údaje týkající se jiné osoby, odpovídá za to, že je oprávněn takové údaje Provozovateli poskytnout."
        }
      ]
    },
    {
      "heading": "3. Účely a právní základy zpracování",
      "blocks": [
        {
          "kind": "clause",
          "number": "3.1.",
          "text": "Provozovatel zpracovává osobní údaje zejména za účelem:"
        },
        {
          "kind": "bullets",
          "items": [
            "registrace a správy uživatelského účtu;",
            "poskytování a provozu Služby;",
            "ukládání nastavení a údajů potřebných pro fungování jednotlivých funkcionalit;",
            "zajištění technického propojení s Brokerem nebo jinými službami třetích osob;",
            "správy předplatného a plateb;",
            "poskytování zákaznické a technické podpory;",
            "zabezpečení Služby a prevence jejího zneužití;",
            "diagnostiky a řešení technických problémů;",
            "ochrany práv a právních nároků Provozovatele;",
            "plnění právních povinností;",
            "zlepšování fungování a uživatelského prostředí Služby;",
            "zasílání obchodních sdělení, jsou-li pro to splněny zákonné podmínky."
          ]
        },
        {
          "kind": "clause",
          "number": "3.2.",
          "text": "Právním základem zpracování je podle konkrétního účelu zejména:"
        },
        {
          "kind": "bullets",
          "items": [
            "poskytování Služby a plnění závazků vzniklých přijetím Obchodních podmínek Uživatelem, včetně zpřístupnění Služby a poskytování funkcionalit v rámci zvoleného předplatného;",
            "splnění právní povinnosti Provozovatele;",
            "oprávněný zájem Provozovatele, zejména na zabezpečení, ochraně a rozvoji Služby, prevenci zneužití a ochraně právních nároků;",
            "souhlas Uživatele, je-li pro konkrétní zpracování vyžadován."
          ]
        },
        {
          "kind": "clause",
          "number": "3.3.",
          "text": "Je-li zpracování založeno na souhlasu, může Uživatel svůj souhlas kdykoli odvolat. Odvoláním souhlasu není dotčena zákonnost zpracování provedeného před jeho odvoláním."
        }
      ]
    },
    {
      "heading": "4. Údaje související s používáním jednotlivých aplikací a funkcionalit",
      "blocks": [
        {
          "kind": "clause",
          "number": "4.1.",
          "text": "Jednotlivé aplikace a funkcionality dostupné prostřednictvím Analytical Platform mohou v závislosti na svém účelu zpracovávat různé kategorie údajů zadaných, vytvořených nebo zpřístupněných Uživatelem."
        },
        {
          "kind": "clause",
          "number": "4.2.",
          "text": "Pokud Uživatel využívá funkcionality pro práci s investičním portfoliem, může Provozovatel zpracovávat zejména údaje o portfoliu, jeho složení, nastavení, zvolených parametrech a kritériích a další údaje potřebné pro fungování příslušné funkcionality."
        },
        {
          "kind": "clause",
          "number": "4.3.",
          "text": "Tyto údaje mohou být zpracovávány prostřednictvím automatizovaných výpočtů, algoritmů a modelů používaných Službou."
        },
        {
          "kind": "clause",
          "number": "4.4.",
          "text": "Provozovatel tyto údaje nezpracovává za účelem individuálního posuzování osobní nebo finanční situace Uživatele ani za účelem posuzování vhodnosti konkrétní investice nebo portfolia pro Uživatele."
        },
        {
          "kind": "clause",
          "number": "4.5.",
          "text": "Automatizované zpracování prováděné v rámci Služby samo o sobě nepředstavuje rozhodování založené výhradně na automatizovaném zpracování, které by vůči Uživateli vyvolávalo právní účinky nebo jej obdobným způsobem významně ovlivňovalo ve smyslu čl. 22 GDPR, není-li u konkrétní funkcionality uvedeno jinak."
        }
      ]
    },
    {
      "heading": "5. Propojení s Brokerem a jinými službami třetích osob",
      "blocks": [
        {
          "kind": "clause",
          "number": "5.1.",
          "text": "Některé aplikace nebo funkcionality Služby mohou umožňovat technické propojení s účtem Uživatele vedeným u poskytovatele investičních služeb (dále jen „Broker“) nebo s jinou službou třetí osoby."
        },
        {
          "kind": "clause",
          "number": "5.2.",
          "text": "Pokud Uživatel takové propojení aktivuje, může Provozovatel zpracovávat údaje nezbytné pro jeho zajištění."
        },
        {
          "kind": "clause",
          "number": "5.3.",
          "text": "Může jít zejména o technické identifikátory, autentizační nebo autorizační údaje a údaje potřebné pro načtení informací o portfoliu nebo poskytování dalších funkcionalit aktivovaných Uživatelem."
        },
        {
          "kind": "clause",
          "number": "5.4.",
          "text": "Provozovatel zpracovává tyto údaje pouze v rozsahu nezbytném pro poskytování příslušné funkcionality."
        },
        {
          "kind": "clause",
          "number": "5.5.",
          "text": "Broker nebo jiný poskytovatel třetí strany může při poskytování svých vlastních služeb zpracovávat osobní údaje jako samostatný správce podle svých vlastních podmínek a zásad ochrany osobních údajů. při poskytování svých vlastních služeb zpracovává osobní údaje podle svých vlastních podmínek a zásad ochrany osobních údajů."
        }
      ]
    },
    {
      "heading": "6. Příjemci osobních údajů",
      "blocks": [
        {
          "kind": "clause",
          "number": "6.1.",
          "text": "Provozovatel osobní údaje neprodává třetím osobám."
        },
        {
          "kind": "clause",
          "number": "6.2.",
          "text": "Osobní údaje mohou být v nezbytném rozsahu zpřístupněny dodavatelům a dalším osobám, jejichž služby Provozovatel využívá pro provoz a poskytování Služby."
        },
        {
          "kind": "note",
          "lines": [
            "Může jít zejména o poskytovatele:"
          ]
        },
        {
          "kind": "bullets",
          "items": [
            "IT, serverové a cloudové infrastruktury;",
            "technické podpory a vývoje;",
            "e-mailových a komunikačních služeb;",
            "analytických, diagnostických a bezpečnostních nástrojů;",
            "platebních služeb;",
            "účetních, daňových a právních služeb."
          ]
        },
        {
          "kind": "clause",
          "number": "6.3.",
          "text": "Pokud taková osoba vystupuje jako zpracovatel osobních údajů, zpracovává osobní údaje pouze na základě pokynů Provozovatele a za podmínek stanovených GDPR."
        },
        {
          "kind": "clause",
          "number": "6.4.",
          "text": "Osobní údaje mohou být dále zpřístupněny orgánům veřejné moci nebo jiným oprávněným osobám, pokud tak stanoví právní předpis nebo rozhodnutí příslušného orgánu."
        }
      ]
    },
    {
      "heading": "7. Předávání osobních údajů mimo Evropský hospodářský prostor",
      "blocks": [
        {
          "kind": "clause",
          "number": "7.1.",
          "text": "Někteří dodavatelé Provozovatele nebo jejich technická infrastruktura mohou být umístěni mimo Evropský hospodářský prostor (EHP)."
        },
        {
          "kind": "clause",
          "number": "7.2.",
          "text": "Pokud dochází k předávání osobních údajů mimo EHP, Provozovatel zajistí, aby k předávání docházelo v souladu s GDPR a při použití odpovídajícího mechanismu ochrany osobních údajů."
        },
        {
          "kind": "clause",
          "number": "7.3.",
          "text": "Takovým mechanismem může být zejména rozhodnutí Evropské komise o odpovídající úrovni ochrany, standardní smluvní doložky schválené Evropskou komisí nebo jiný mechanismus přípustný podle GDPR."
        }
      ]
    },
    {
      "heading": "8. Doba uchování osobních údajů",
      "blocks": [
        {
          "kind": "clause",
          "number": "8.1.",
          "text": "Provozovatel uchovává osobní údaje pouze po dobu nezbytnou pro účely, pro které jsou zpracovávány, nebo po dobu stanovenou právními předpisy."
        },
        {
          "kind": "clause",
          "number": "8.2.",
          "text": "Údaje související s uživatelským účtem a poskytováním Služby jsou zpravidla uchovávány po dobu trvání uživatelského účtu nebo předplatného a následně po dobu nezbytnou pro ochranu právních nároků Provozovatele."
        },
        {
          "kind": "clause",
          "number": "8.3.",
          "text": "Účetní, daňové a související dokumenty jsou uchovávány po dobu stanovenou příslušnými právními předpisy."
        },
        {
          "kind": "clause",
          "number": "8.4.",
          "text": "Údaje zpracovávané na základě souhlasu jsou uchovávány do odvolání souhlasu nebo do uplynutí doby, pro kterou byl souhlas udělen, není-li dán jiný právní důvod pro jejich další zpracování."
        },
        {
          "kind": "clause",
          "number": "8.5.",
          "text": "Technické, provozní a bezpečnostní záznamy mohou být uchovávány po dobu nezbytnou pro zabezpečení Služby, diagnostiku problémů, prevenci zneužití a ochranu právních nároků."
        },
        {
          "kind": "clause",
          "number": "8.6.",
          "text": "Po uplynutí příslušné doby jsou osobní údaje vymazány nebo anonymizovány, není-li dán jiný právní důvod pro jejich další uchování."
        }
      ]
    },
    {
      "heading": "9. Obchodní sdělení",
      "blocks": [
        {
          "kind": "clause",
          "number": "9.1.",
          "text": "Provozovatel může Uživateli zasílat obchodní sdělení, pokud jsou pro to splněny podmínky stanovené právními předpisy."
        },
        {
          "kind": "clause",
          "number": "9.2.",
          "text": "Pokud je zasílání obchodních sdělení založeno na souhlasu Uživatele, může Uživatel tento souhlas kdykoli odvolat."
        },
        {
          "kind": "clause",
          "number": "9.3.",
          "text": "Je-li Uživatel zákazníkem Provozovatele, může mu Provozovatel za podmínek stanovených právními předpisy zasílat informace o vlastních obdobných produktech nebo službách."
        },
        {
          "kind": "clause",
          "number": "9.4.",
          "text": "Uživatel se může ze zasílání obchodních sdělení kdykoli odhlásit prostřednictvím odkazu uvedeného v příslušném sdělení nebo kontaktováním Provozovatele."
        },
        {
          "kind": "clause",
          "number": "9.5.",
          "text": "Odhlášení z obchodních sdělení nemá vliv na provozní, servisní, bezpečnostní nebo jiné zprávy nezbytné pro poskytování Služby."
        }
      ]
    },
    {
      "heading": "10. Zabezpečení osobních údajů",
      "blocks": [
        {
          "kind": "clause",
          "number": "10.1.",
          "text": "Provozovatel přijímá přiměřená technická a organizační opatření k ochraně osobních údajů před neoprávněným přístupem, ztrátou, zneužitím, změnou, zpřístupněním nebo zničením."
        },
        {
          "kind": "clause",
          "number": "10.2.",
          "text": "Přístup k osobním údajům je omezen na osoby, které jej potřebují pro plnění svých pracovních nebo smluvních povinností a které jsou vázány odpovídající povinností mlčenlivosti."
        },
        {
          "kind": "clause",
          "number": "10.3.",
          "text": "Přesto nelze u žádného informačního systému nebo přenosu dat prostřednictvím internetu zaručit absolutní bezpečnost."
        }
      ]
    },
    {
      "heading": "11. Práva Uživatele",
      "blocks": [
        {
          "kind": "clause",
          "number": "11.1.",
          "text": "Za podmínek stanovených GDPR má Uživatel zejména:"
        },
        {
          "kind": "bullets",
          "items": [
            "právo získat informace o zpracování svých osobních údajů a právo na přístup k nim;",
            "právo na opravu nepřesných nebo doplnění neúplných osobních údajů;",
            "právo na výmaz osobních údajů;",
            "právo na omezení zpracování;",
            "právo na přenositelnost osobních údajů;",
            "právo vznést námitku proti zpracování založenému na oprávněném zájmu;",
            "právo kdykoli vznést námitku proti zpracování pro účely přímého marketingu;",
            "právo odvolat souhlas, je-li zpracování založeno na souhlasu;",
            "právo podat stížnost u příslušného dozorového úřadu."
          ]
        },
        {
          "kind": "clause",
          "number": "11.2.",
          "text": "Tato práva nejsou absolutní a uplatní se za podmínek a v rozsahu stanoveném GDPR a dalšími příslušnými právními předpisy."
        },
        {
          "kind": "clause",
          "number": "11.3.",
          "text": "Odvoláním souhlasu není dotčena zákonnost zpracování provedeného před jeho odvoláním."
        }
      ]
    },
    {
      "heading": "12. Uplatnění práv a stížnosti",
      "blocks": [
        {
          "kind": "clause",
          "number": "12.1.",
          "text": "Uživatel může svá práva uplatnit prostřednictvím kontaktních údajů Provozovatele uvedených níže."
        },
        {
          "kind": "clause",
          "number": "12.2.",
          "text": "Provozovatel může před vyřízením žádosti přiměřeným způsobem ověřit totožnost žadatele, pokud je to nezbytné k ochraně osobních údajů."
        },
        {
          "kind": "clause",
          "number": "12.3.",
          "text": "Provozovatel vyřizuje žádosti ve lhůtách stanovených GDPR."
        },
        {
          "kind": "clause",
          "number": "12.4.",
          "text": "Pokud se Uživatel domnívá, že jsou jeho osobní údaje zpracovávány v rozporu s právními předpisy, má právo podat stížnost u příslušného dozorového úřadu, kterým je v České republice zejména:"
        },
        {
          "kind": "note",
          "lines": [
            "Úřad pro ochranu osobních údajů",
            "Pplk. Sochora 27",
            "170 00 Praha 7"
          ]
        }
      ]
    },
    {
      "heading": "13. Změny Zásad",
      "blocks": [
        {
          "kind": "clause",
          "number": "13.1.",
          "text": "Provozovatel může tyto Zásady v přiměřeném rozsahu měnit zejména v návaznosti na změny Služby, používaných technologií, způsobu zpracování osobních údajů nebo právních předpisů."
        },
        {
          "kind": "clause",
          "number": "13.2.",
          "text": "Aktuální znění Zásad je dostupné prostřednictvím Analytical Platform nebo na webových stránkách Provozovatele."
        },
        {
          "kind": "clause",
          "number": "13.3.",
          "text": "O podstatných změnách může být Uživatel informován také jiným přiměřeným způsobem."
        }
      ]
    },
    {
      "heading": "14. Kontaktní údaje",
      "blocks": [
        {
          "kind": "clause",
          "number": "14.1.",
          "text": "V případě dotazů týkajících se ochrany osobních údajů nebo při uplatnění práv podle těchto Zásad může Uživatel kontaktovat Provozovatele:"
        },
        {
          "kind": "note",
          "lines": [
            "CCFR",
            "E-mail: app@analyticalplatform.com",
            "Telefon: +420 530 338 808"
          ]
        }
      ]
    }
  ]
};

export default privacyPolicyCs;
